/**
 * @author Daniel Aguirre
 * @file routes.js
 * @description Patient routes
 */

// Pages
import DashboardDetail from '@nephro/pages/DashboardDetail';
import RecommendedBySchedulingList from '@nephro/pages/DashboardStaff/components/lists/RecommendedBySchedulingList';
import MissedAppointmentsByStageList from '@nephro/pages/DashboardStaff/components/lists/MissedAppointmentsByStageList';
import AntibodyAntiHBsList from '@nephro/pages/DashboardStaff/components/lists/AntiBodyAntiHBsList';
import AmbulatoryMonitoringIB from '@nephro/pages/DashboardStaff/components/lists/AmbulatoryMonitoringIB';
import AmbulatoryMonitoringIG from '@nephro/pages/DashboardStaff/components/lists/AmbulatoryMonitoringIG';
import ProteinuriaDetailList from '@nephro/pages/DashboardStaff/components/lists/ProteinuriaDetailList';
import AlbuminuriaF13List from '@nephro/pages/DashboardStaff/components/lists/AlbuminuriaF13List';
import NutritionalIndicatorList from '@nephro/pages/DashboardStaff/components/lists/NutritionalIndicatorList';
import AlbuminuriaProgressList from '@nephro/pages/DashboardStaff/components/lists/AlbuminuriaProgressList';
import TFGDeteriorationList from '@nephro/pages/DashboardStaff/components/lists/TFGDeteriorationList';
import HemoglobinList from '@nephro/pages/DashboardStaff/components/lists/HemoglobinList';
import PotassiumList from '@nephro/pages/DashboardStaff/components/lists/PotassiumList';
import MetabolicControlDiabetesList from '@nephro/pages/DashboardStaff/components/lists/MetabolicControlDiabetesList';
import PhosphorusList from '@nephro/pages/DashboardStaff/components/lists/PhosphorusList';
import AlbuminaList from '@nephro/pages/DashboardStaff/components/lists/AlbuminaList';
import PthIndicatorList from '@nephro/pages/DashboardStaff/components/lists/PthIndicatorList';
import SeroStatusHepatitisBList from '@nephro/pages/DashboardStaff/components/lists/SeroStatusHepatitisBList';
import RiskList from '@nephro/pages/DashboardStaff/components/lists/RiskList';
import BloodPressureList from 'pages/DashboardStaff/components/lists/BloodPressureList';
import VaccineSchedulingList from '@nephro/pages/DashboardStaff/components/lists/VaccineSchedulingList';
import PostVaccineAntiHbsList from '@nephro/pages/DashboardStaff/components/lists/PostVaccineAntiHbsList';
import RiskRegisterList from '@nephro/pages/DashboardStaff/components/lists/RiskRegisterList';
import LossHepatitisImmunityList from '@nephro/pages/DashboardStaff/components/lists/LossHepatitisImmunityList';
import CorrelationRiskRateProgressionList from '@nephro/pages/DashboardStaff/components/lists/CorrelationRiskRateProgressionList';
import TreatmentOptionsList from '@nephro/pages/DashboardStaff/components/lists/TreatmentOptionsList';
import Access from '@nephro/pages/DashboardStaff/components/lists/Access';
import PsychosocialRiskPsycologyList from '@nephro/pages/DashboardStaff/components/lists/PsychosocialRiskPsycologyList';
import SchedulingAlertList from '@nephro/pages/DashboardStaff/components/lists/SchedulingAlertList';
import ProteinEnergeticWearList from '@nephro/pages/DashboardStaff/components/lists/ProteinEnergeticWearList';
import GeneralSocialTSocialRiskList from '@nephro/pages/DashboardStaff/components/lists/GeneralSocialTSocialRiskList';
import AssesmentInPsychologyList from '@nephro/pages/DashboardStaff/components/lists/AssesmentInPsychologyList';
import NursingEducationList from '@nephro/pages/DashboardStaff/components/lists/NursingEducationList';
import DissentWithoutPsychologyAssessmentList from 'pages/DashboardStaff/components/lists/DissentWithoutPsychologyAssessmentList';
import PatientEventsList from '@nephro/pages/DashboardStaff/components/lists/PatientEventsList';
import PeriodicityAttentionList from '@nephro/pages/DashboardStaff/components/lists/PeriodicityAttentionList';
import ConstructionAccessAssessmentList from '@nephro/pages/DashboardStaff/components/lists/ConstructionAccessAssessmentList';
import PsychosocialRiskList from '@nephro/pages/DashboardStaff/components/lists/PsychosocialRiskList';
import GeneralSocialRiskRegisterList from '@nephro/pages/DashboardStaff/components/lists/GeneralSocialRiskRegisterList';
import FollowUpAbsenteeismAdherenceList from '@nephro/pages/DashboardStaff/components/lists/FollowUpAbsenteeismAdherenceList';

const pathStart = '/main/dashboard-detail';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: DashboardDetail,
    exact: true
  },
  {
    path: `${pathStart}/recommended-by-scheduling/:date/:totalItems`,
    isProtected: true,
    component: RecommendedBySchedulingList,
    exact: true
  },
  {
    path: `${pathStart}/missed-appointments-by-stage/:stage/:totalItems`,
    isProtected: true,
    component: MissedAppointmentsByStageList,
    exact: true
  },
  {
    path: `${pathStart}/antibody-anti-hbs/:classification/:totalItems`,
    isProtected: true,
    component: AntibodyAntiHBsList,
    exact: true
  },
  {
    path: `${pathStart}/ambulatory-monitoring-ib/:classification/:totalItems`,
    isProtected: true,
    component: AmbulatoryMonitoringIB,
    exact: true
  },
  {
    path: `${pathStart}/ambulatory-monitoring-iG/:classification/:totalItems`,
    isProtected: true,
    component: AmbulatoryMonitoringIG,
    exact: true
  },
  {
    path: `${pathStart}/proteinuria/:proteinuriaDetail/:totalItems`,
    isProtected: true,
    component: ProteinuriaDetailList,
    exact: true
  },
  {
    path: `${pathStart}/albuminuria/:shift/:totalItems`,
    isProtected: true,
    component: AlbuminuriaF13List,
    exact: true
  },
  {
    path: `${pathStart}/albuminuria-progress/:variacion/:totalItems`,
    isProtected: true,
    component: AlbuminuriaProgressList,
    exact: true
  },
  {
    path: `${pathStart}/tfg-deterioration/:deterioroSeleccionado/:totalItems`,
    isProtected: true,
    component: TFGDeteriorationList,
    exact: true
  },
  {
    path: `${pathStart}/nutritional-indicator/:stage/:classification/:totalItems`,
    isProtected: true,
    component: NutritionalIndicatorList,
    exact: true
  },
  {
    path: `${pathStart}/hemoglobin/:clasificacionSeleccionada/:totalItems`,
    isProtected: true,
    component: HemoglobinList,
    exact: true
  },
  {
    path: `${pathStart}/potassium/:classification/:totalItems`,
    isProtected: true,
    component: PotassiumList,
    exact: true
  },
  {
    path: `${pathStart}/metabolic-control-diabetes/:classification/:totalItems`,
    isProtected: true,
    component: MetabolicControlDiabetesList,
    exact: true
  },
  {
    path: `${pathStart}/phosphorus/:classification/:totalItems`,
    isProtected: true,
    component: PhosphorusList,
    exact: true
  },
  {
    path: `${pathStart}/albumina-lab/:classification/:totalItems`,
    isProtected: true,
    component: AlbuminaList,
    exact: true
  },
  {
    path: `${pathStart}/pth/:classification/:stage/:totalItems`,
    isProtected: true,
    component: PthIndicatorList,
    exact: true
  },
  {
    path: `${pathStart}/seroStatusHepatitisB/:classification/:totalItems`,
    isProtected: true,
    component: SeroStatusHepatitisBList,
    exact: true
  },
  {
    path: `${pathStart}/risk/:classification/:date/:totalItems`,
    isProtected: true,
    component: RiskList,
    exact: true
  },
  {
    path: `${pathStart}/bloodPressure/:classification/list/:totalItems`,
    isProtected: true,
    component: BloodPressureList
  },
  {
    path: `${pathStart}/vaccine-scheduling/:vaccineMonth/:dose/:totalItems`,
    isProtected: true,
    component: VaccineSchedulingList,
    exact: true
  },
  {
    path: `${pathStart}/post-vaccine-anti-hbs/:classification/:totalItems`,
    isProtected: true,
    component: PostVaccineAntiHbsList,
    exact: true
  },
  {
    path: `${pathStart}/access/:classification/:totalItems`,
    isProtected: true,
    component: Access,
    exact: true
  },
  {
    path: `${pathStart}/risk-register/:classification/:totalItems`,
    isProtected: true,
    component: RiskRegisterList,
    exact: true
  },
  {
    path: `${pathStart}/loss-hepatitis-immunity/:classification/:totalItems`,
    isProtected: true,
    component: LossHepatitisImmunityList,
    exact: true
  },
  {
    path: `${pathStart}/correlation-risk-rate-progression/:classification/:proggression/:totalItems`,
    isProtected: true,
    component: CorrelationRiskRateProgressionList,
    exact: true
  },
  {
    path: `${pathStart}/treatment-options`,
    isProtected: true,
    component: TreatmentOptionsList,
    exact: true
  },
  {
    path: `${pathStart}/psychosocial-risk-psycology/:riskParam/:month/:totalItems`,
    isProtected: true,
    component: PsychosocialRiskPsycologyList,
    exact: true
  },
  {
    path: `${pathStart}/scheduling-alert-list/:classification/:totalItems`,
    isProtected: true,
    component: SchedulingAlertList,
    exact: true
  },
  {
    path: `${pathStart}/protein-energetic-wear-list/:classification/:totalItems`,
    isProtected: true,
    component: ProteinEnergeticWearList,
    exact: true
  },
  {
    path: `${pathStart}/general-social-t-social-risk-list/:classification/:totalItems`,
    isProtected: true,
    component: GeneralSocialTSocialRiskList,
    exact: true
  },
  {
    path: `${pathStart}/assesment-in-psychology/:classification/:totalItems`,
    isProtected: true,
    component: AssesmentInPsychologyList,
    exact: true
  },
  {
    path: `${pathStart}/nursing-education/:classification/:totalItems`,
    isProtected: true,
    component: NursingEducationList,
    exact: true
  },
  {
    path: `${pathStart}/dissent-psychology-assessment/:classification/:totalItems`,
    isProtected: true,
    component: DissentWithoutPsychologyAssessmentList,
    exact: true
  },
  {
    path: `${pathStart}/patient-events/:classification/:totalItems`,
    isProtected: true,
    component: PatientEventsList,
    exact: true
  },
  {
    path: `${pathStart}/periodicity-attention/:classification/:frequency/:totalItems`,
    isProtected: true,
    component: PeriodicityAttentionList,
    exact: true
  },
  {
    path: `${pathStart}/construction-access-assessment-list/:classification/:totalItems`,
    isProtected: true,
    component: ConstructionAccessAssessmentList,
    exact: true
  },
  {
    path: `${pathStart}/psychosocial-risk-list/:classification/:totalItems`,
    isProtected: true,
    component: PsychosocialRiskList,
    exact: true
  },
  {
    path: `${pathStart}/general-social-risk-register/:classification/:totalItems`,
    isProtected: true,
    component: GeneralSocialRiskRegisterList,
    exact: true
  },
  {
    path: `${pathStart}/follow-up-absenteeism-adherence/:classification/:phase/:totalItems`,
    isProtected: true,
    component: FollowUpAbsenteeismAdherenceList,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
